<template>
  <h3 class="popup-title">
    <slot></slot>
  </h3>
</template>

<script>
export default {};
</script>

<style scoped>
.popup-title {
  margin: 4px 0 24px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 500;
}
</style>
